module.exports = __webpack_public_path__ + "images/8fff2015e6d940b9e0dfdd7ae5cda680.svg";